import { render } from "./CollectionStoreTable.vue?vue&type=template&id=2bda9372&scoped=true"
import script from "./CollectionStoreTable.vue?vue&type=script&lang=js"
export * from "./CollectionStoreTable.vue?vue&type=script&lang=js"

import "./CollectionStoreTable.vue?vue&type=style&index=0&id=2bda9372&lang=less&scoped=true"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bda9372"]])

export default __exports__